import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { InfoComponent } from '../objects/info/info/info.component';
import { LoadingComponent } from '../objects/loading/loading.component';
import { AlertComponent } from '../objects/alert/alert/alert.component';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { ComprasProveedorComponent } from './compras-proveedor/compras-proveedor.component';
import { DetalleCompra } from 'src/app/Models/compra/detallecompra/detalle-compra';
import { Compra } from 'src/app/Models/compra/compra/compra';
import { Proveedor } from 'src/app/Models/proveedor/proveedor';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { ComprasArticuloComponent } from './compras-detcompra/compras-detcompra.component';
import { ArticuloDialogComponent } from '../articulo/articulo-dialog/articulo-dialog.component';
import { Articulo } from 'src/app/Models/articulo/articulo';
import { Precio } from 'src/app/Models/precio/precio';
import { Moneda } from 'src/app/Models/moneda/moneda';
import { Guia } from 'src/app/Models/guia/guia';
import { SearchFacturaComponent } from './search-factura/search-factura.component';
import { Title } from '@angular/platform-browser';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { AddCompraComponent } from './add-compra/add-compra.component';
import * as moment from 'moment';

@Component({
  selector: 'app-compras',
  templateUrl: './compras.component.html',
  styleUrls: ['./compras.component.css']
})
export class ComprasComponent implements OnInit {
  @ViewChild('btnshow', null) btnshowcompr: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('inptprove', null) inptprove: ElementRef;
  @ViewChild('listadetcompras', null) listadetcompras: ElementRef;
  @ViewChild('icon', null) icon: ElementRef;
  @ViewChild(ComprasProveedorComponent, null) public fmrcomprasproveedor: ComprasProveedorComponent;
  @ViewChild(ComprasArticuloComponent, null) public frmcomprasdetalles: ComprasArticuloComponent;
  @ViewChild(ArticuloDialogComponent, null) public fmarticulodialog: ArticuloDialogComponent;
  @ViewChild(SearchFacturaComponent, null) public frmsearchfactura: SearchFacturaComponent;
  @ViewChild(AddCompraComponent, null) public newcompra: AddCompraComponent;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  @ViewChild('txtdireccion', null) txtdireccion: ElementRef;
  expandedStates: boolean[] = [false];
  public usuario: Usuario = new Usuario();
  public compra: Compra = new Compra();
  public articulo: Articulo = new Articulo();
  public precio: Precio = new Precio();
  public proveedor: Proveedor = new Proveedor();
  public detcompras: DetalleCompra[] = [];
  public monedas: Moneda[] = [];

  public facturas: any[] = [];
  public tipo_filtro: number = 0;
  public guias: Guia[] = [];
  public compras: Compra[] = [];
  public filtro: Filtro = new Filtro();
  public testitem: DetalleCompra = new DetalleCompra();
  public detcompra: DetalleCompra = new DetalleCompra();
  public alertType: AlertType = new AlertType();
  public options: ALertOption = new ALertOption();
  public isadddetcompra: boolean = false;
  public isnota: boolean = false
  public index: number = 0;
  public numitem: number = 1;
  public pagarticulo: any;
  public fechaHoraActual = new Date();
  public search = { top: 10, clase: 0, subclase: 0, subgrupo: 0, nombre: '', codigo: '', opcion: 'nombre', scale: 'DESC', fechaprogd: this.data.DateNowCurrent(), fechaprogh: this.data.DateNowCurrent() }
  constructor(private title: Title, private data: DataService, private notify: NotifyService, private auth: AuthService, private route: Router) {
    const firstDayOfMonth = new Date(this.fechaHoraActual.getFullYear(), this.fechaHoraActual.getMonth(), 1);
    this.filtro.fecini = moment(firstDayOfMonth).format('YYYY-MM-DD');
    this.filtro.fecfin = moment(this.fechaHoraActual).format('YYYY-MM-DD');
    this.filtro.tipofecha = 'fecemi'
    this.filtro.idsucursal = data.getSucursalId()
    this.mostrarFiltro()
  }

  ngOnInit() {
    this.title.setTitle('Facturación | Sistema de ventas');
    this.usuario = this.auth.getCurrentUser();
    //this.getFacturas();
  }

  getFacturas() {
    this.data.GetSimple(this.data.api.factura).subscribe(r => {
      console.log(r);

      this.compras = r;
    })
  }
  reiniciarFiltro() {
    this.filtro = {
      ...this.reiniciarObjetoFiltro(this.filtro), // Copia los campos tipofecha, fecini, fecfin
    };
  }

  // Función para reiniciar el objeto filtro manteniendo tipofecha, fecini, fecfin
  private reiniciarObjetoFiltro(obj: Filtro): Partial<Filtro> {
    const { tipofecha, fecini, fecfin } = obj;
    return { tipofecha, fecini, fecfin };
  }

  showfrmproveedor() {
    // this.newproveedor.show(()=>{
    //   this.proveedor=this.newproveedor.proveedor;
    // })
  }

  mostrarFiltro() {
    console.log(this.filtro);
    this.data.Post('filtrardoc/Compras', this.filtro).subscribe(r => {
      console.log(r);
      if (r.status === 'error') {
        this.compras = [];
        // this.data.notify(r.message,"Error",this.alertType.error);

      } else {
        this.compras = r.data;
      }


    }), (e => { this.data.notify(e.message, "Error", this.alertType.error); })

  }

  editCompra(i) {
    this.newcompra.serie_boleta = this.data.getSerieBoleta();
    this.newcompra.serie_factura = this.data.getSerieFactura();
    this.newcompra.compra = new Compra()
    this.newcompra.compra = i
    this.newcompra.proveedor = i.idprovee
    console.log(i);
    this.newcompra.isedit = true
    this.newcompra.show(() => {

      console.log("cerrado");
      this.mostrarFiltro();
    })
  }

  showfrmfactura() {
    this.newcompra.serie_boleta = this.data.getSerieBoleta();
    this.newcompra.serie_factura = this.data.getSerieFactura();
    this.newcompra.compra = new Compra()
    this.newcompra.proveedor = new Proveedor()
    this.newcompra.detcompras = []
    this.newcompra.isedit = false
    this.newcompra.show(() => {

      console.log("cerrado");
      this.mostrarFiltro();
    })
  }

  eliminarCompra(item: Compra) {
    const confirmar = confirm(
      `¿Está seguro de eliminar la compra ${item.documento} ${item.serie}-${item.numero}?\n` +
      `Esta acción revertirá el stock de todos los artículos y no se puede deshacer.`
    );

    if (!confirmar) return;

    this.data.Delete(`compra/${item.idcompra}/eliminar`).subscribe(
      (r: any) => {
        if (r.status === 'success') {
          this.data.notify('Compra eliminada y stock revertido.', 'Éxito', this.alertType.success, this.options);
          this.mostrarFiltro();
        } else {
          this.data.notify(r.message || 'Error al eliminar', 'Error', this.alertType.error);
        }
      },
      (e) => {
        this.data.notify('Error al eliminar la compra.', 'Error', this.alertType.error);
        console.error(e);
      }
    );
  }
}
